export const YCLIENTS_BOOKING_URL = 'https://n1689603.yclients.com/';
